import React from "react";
import Banner from "../common/Banner";
import policy from "../../data/privacyPolicy.json";
import images from "../../assets/images/Constant";

export default function PrivacyPolicyPage() {
  const sections = policy?.sections || [];
  const two = policy?.twoColumn || {};

  return (
    <>
      <Banner
        title={policy?.banner?.title || "Privacy Policy"}
        currentLabel={policy?.banner?.breadcrumb || "Privacy Policy"}
      />

      <section className="max-w-[1200px] mx-auto px-4 sm:px-6 py-12 sm:py-16">
      <div className="flex gap-2 justify-center ">
      <img src={images[policy.icon]} alt=""  className=""/>
          <span className="text-base md:text-[22px] uppercase tracking-widest font-medium text-primary">
            {policy.eyebrow}
          </span>
</div>
        <h1 className="mt-3 text-center text-3xl md:text-[44px] font-semibold text-[#0b2c3d]">
          {policy?.title || "Privacy Policy"}
        </h1>

        <div className="mt-12 space-y-10">
          {sections.map((s, i) => (
            <div key={`${s.heading}-${i}`}>
              <h2 className="text-lg md:text-xl font-semibold text-[#0b2c3d]">
                {s.heading}
              </h2>
              <div className="mt-3 space-y-4 text-sm text-[#9CA3AF] leading-relaxed">
                {(s.paragraphs || []).map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-10 mb-16">
          <div>
            <h3 className="text-lg font-semibold text-[#0b2c3d]">
              {two?.left?.heading}
            </h3>
            <div className="mt-3 space-y-4 text-sm text-[#9CA3AF] leading-relaxed">
              {(two?.left?.paragraphs || []).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-[#0b2c3d]">
              {two?.right?.heading}
            </h3>
            <div className="mt-3 space-y-4 text-sm text-[#9CA3AF] leading-relaxed">
              {(two?.right?.paragraphs || []).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

